import { appInitialState } from 'core/store/reducers/appReducer/AppSlice';
import { assetsInitialState } from 'core/store/reducers/assetsReducer/AssetsInitialState';
import { canvasInitialState } from 'core/store/reducers/canvasReducer/CanvasSlice';
import { charactersInitialState } from 'core/store/reducers/characterStudioReducer/CharaterStudioSlice';
import { homeInitialState } from 'core/store/reducers/homeReducer/HomeSlice';
import { intermediateMediaInitialState } from 'core/store/reducers/intermediateMediaReducer/IntermediateMediaSlice';
import { profileInitialState } from 'core/store/reducers/profileReducer/ProfileSlice';
import { studioInitialState } from 'core/store/reducers/studioReducer/StudioSlice';
import { createTransform } from 'redux-persist';

const persistedStateProperties = {
	studio: [
		'feedView',
		'feedType',
		'models',
		'fluxModels',
		'fluxStyles',
		'lightningModels',
		'modelCategories',
		'studioFeedBatchWiseMap',
		'studioFeedChronologicalBatchIdList',
		'studioMediaMap',
		'studioMediaList',
		'loras',
		'promptInput',
		'productPhotoImageToVideoGuideToggle',
	],
	canvas: [
		'models',
		'fluxModels',
		'lightningModels',
		'canvasFeedDataMap',
		'canvases',
		'canvasProperty',
		'canvasViewportCenterMap',
		'modelCategories',
		'loraCategories',
		'styleCategories',
		'styles',
		'fluxStyles',
		'promptInput',
		'productPhotoImageToVideoGuideToggle',
	],
	assets: ['assets', 'assetsMap'],
	characterStudio: ['listCharacters'],
	home: ['prompts', 'models'],
	app: ['productPhotoGuideToggle'],
	profile: [],
	intermediateMedia: [],
	api: [],
};

const defaultState = {
	studio: studioInitialState,
	canvas: canvasInitialState,
	assets: assetsInitialState,
	characterStudio: charactersInitialState,
	home: homeInitialState,
	app: appInitialState,
	profile: profileInitialState,
	intermediateMedia: intermediateMediaInitialState,
	api: {},
};

export const getNewDefaultState = () => {
	const newState = {};
	Object.entries(defaultState).forEach(([key, state]) => {
		newState[key] = { ...state };
	});
	return newState;
};

const getTransformForStoredProperties = (stateKey) => {
	return createTransform(
		(inboundState) => {
			const data = {};
			persistedStateProperties[stateKey].forEach((property) => {
				if (property === 'canvasFeedDataMap') {
					Object.keys(inboundState[property]).forEach((canvasId) => {
						const canvasData = inboundState[property][canvasId];
						const canvasDataMedia = { ...canvasData.media };
						Object.entries(canvasData.media ?? {}).forEach(([mediaId, media]) => {
							if (media.status === 'failed') delete canvasDataMedia[mediaId];
						});
						data[property] = {
							...(data[property] ?? {}),
							[canvasId]: {
								media: canvasDataMedia,
								assets: {},
							},
						};
					});
				} else if (property === 'studioFeedChronologicalBatchIdList') {
					data[property] = inboundState[property].slice(0, 20);
					const mediaIds = [];
					data[property].forEach((batchId) => {
						mediaIds.push.apply(
							Object.keys(inboundState.studioFeedBatchWiseMap?.[batchId]?.derivedMedia ?? {}),
						);
					});
					data.studioMediaList = mediaIds;
				} else {
					data[property] = inboundState[property];
				}
			});
			return data;
		},
		(outboundState, key) => {
			return {
				...defaultState?.[key],
				...outboundState,
			};
		},
		{ whitelist: [stateKey] },
	);
};

const transforms = Object.keys(persistedStateProperties).map(getTransformForStoredProperties);

export default transforms;
